import React from 'react'

import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import { grey } from '@material-ui/core/colors';
import { fade } from '@material-ui/core/styles/colorManipulator';
import Box from '@material-ui/core/Box';
import Zoom from '@material-ui/core/Zoom';
import Fade from '@material-ui/core/Fade';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import Typography from '@material-ui/core/Typography';
import CheckIcon from '@material-ui/icons/Check';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const styles = (theme: Theme) => ({
  displaySwatches: {
    fontSize: '12px',
  },
  gridList: {
    height: 'auto',
  },
  titleBar: {
    'text-align': 'center',
      backgroundColor: 'transparent'  
  },
  titlePosition: {
    top: '28%',
    [theme.breakpoints.up('sm')]: {
      top: '35%'
    },
  },
  box: {
    height: '100%',
    '&:hover': {
      boxShadow: theme.shadows[2],
      cursor: 'pointer',
    }
  },
  swatches: {
    width: '100%',
    height: '100%'
  },
  cardActionArea: {
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      height: 149
    },
    
  }
});

interface Props {
  colors: string[];
  width: string
}

interface State {
  colorSelected: string,
  colorHovered: string
}

type PropsWithStyles = Props & WithStyles<'displaySwatches' | 'gridList' | 'titleBar' | 'titlePosition' | 'box' | 'swatches' | 'cardActionArea'>;

class Swatches extends React.Component<PropsWithStyles, State> {

  constructor(props: PropsWithStyles) {
    super(props);
    this.state = {
        colorSelected: '',
        colorHovered: ''
    }
  }

  handleColorCopied = (color: string) => {
    this.setState({
      colorSelected: color
    });
  }  

  handleColorHovered = (color: string) => {
    this.setState({
      colorHovered: color
    });
  } 

render() {
  const { classes, width } = this.props;
  
  const renderSwatches = (type: string, colors: string[]) => {
    return colors.map((color: string, id: number) => {

      const normalizeColorValue =
        Array.isArray(color) && type === 'rgb'
          ? `rgb(${color[0]}, ${color[1]}, ${color[2]})`
          : color
      const isColorCopied: boolean = color === this.state.colorSelected 
      const isColorHovered: boolean = color === this.state.colorHovered  
      return (
        <Card key={id} elevation={0}>
          <CardActionArea className={classes.cardActionArea}>
            <CopyToClipboard text={color} 
                onCopy={() => { this.handleColorCopied(color) }}
            >
              <GridListTile 
                cols={1} 
                style={{ color }} 
                className={classes.box}
                onMouseEnter={() => { this.handleColorHovered(color) }} 
                onMouseLeave={() => { this.handleColorHovered(color) }}
              >
                <div
                  className={classes.swatches}
                  style={{
                    backgroundColor: normalizeColorValue,
                    color: normalizeColorValue
                  }}
                />
                <GridListTileBar
                  title={color}
                  titlePosition="top"
                  className={classes.titleBar}
                  classes={{
                    titlePositionTop: classes.titlePosition
                  }}
                />
                  {isColorCopied &&
                    <Zoom 
                      in={true}
                      style={{ transitionDelay: '195ms' }}
                    >
                      <Box
                        position="absolute"
                        top={width === 'xs' ? '5%' : '15%'}
                        left={width === 'xs' ? '45%' : '42%'}
                        color="common.white"
                        zIndex="tooltip"
                      >
                        <CheckIcon fontSize='large' />
                      </Box>
                    </Zoom>
                  }
                  {isColorHovered && !isColorCopied &&
                  <Fade 
                  in={true}
                  style={{ transitionDelay: '100ms' }}
                >
                    <Box
                      position="absolute"
                      top={0}
                      left={0}
                      height={'100%'}
                      width={'100%'}
                      padding={4}
                      textAlign="center"
                      bgcolor={fade(grey[900], 0.3)}
                      color="common.white"
                      zIndex="drawer"
                    >
                      <Typography variant="body1">Copy</Typography>
                    </Box>  
                    </Fade>
                  }
              </GridListTile>
            </CopyToClipboard>
          </CardActionArea>
        </Card>
                
      )
    })
  }

  return (  
    <div className={classes.displaySwatches}>
      <GridList cellHeight={width === 'xs' ? 100 : 150} cols={width === 'xs' ? 1 : 2} className={classes.gridList} spacing={8}>
        {renderSwatches('hex', this.props.colors)}
      </GridList>
    </div>
  );
}

}

export default withWidth()(withStyles(styles)(Swatches));  
